import { Trans, useTranslation } from "react-i18next";
import {
  ListContaniner,
  PrivacyPolicyText,
  SectionContainer,
  SectionTitle,
  SubSectionContainer,
} from "../PrivacyPolicyContent.styled";

export const ChangesPrivacyPolicySectionContent = (
  props: ChangesPrivacyPolicySectionContentProps
) => {
  const { i18n } = useTranslation();

  return (
    <SectionContainer>
      <SectionTitle>
        <Trans i18nKey={"privacyPolicy.changesPrivacyPolicy.title"} />
      </SectionTitle>
      <SubSectionContainer>
        <ListContaniner>
          {(
            i18n.t("privacyPolicy.changesPrivacyPolicy.list", {
              returnObjects: true,
            }) as string[]
          ).map((definition, index) => (
            <PrivacyPolicyText>
              <Trans i18nKey={definition} />
            </PrivacyPolicyText>
          ))}
        </ListContaniner>
      </SubSectionContainer>
    </SectionContainer>
  );
};

export interface ChangesPrivacyPolicySectionContentProps {}
